/*
 * @Author: Junchi Zhao
 * @LastEditors: Please set LastEditors
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from "./App";
import router, { resetRouter } from "./router";
import store from "./store";
// 解决Added non-passive event listener to a scroll-blocking 'mousewheel' event. Consider marking event han
// import 'default-passive-events'
import "@wangeditor/editor/dist/css/style.css";
import "@/assets/atom.css";
import "@/assets/base.scss";
import "@/assets/defaultPage.scss";
import "@/assets/font/iconfont.css";
import "@/assets/element-variables.scss";
import "nprogress/nprogress.css";
// 引入axios，并加到原型链中
import axios from "./data/request";
window.axios = axios;
import api from "./data/fetchType";
import { baseURL, wsURL, isOpenWs, getGlobalConfig } from "./config";
//路由守卫
import "@/router/routeGuard";
//配置接口地址
Vue.prototype.isOpenWs = isOpenWs;
Vue.prototype.wsURL = wsURL;
Vue.prototype.baseURL = baseURL;
Vue.prototype.getGlobalConfig = getGlobalConfig;
Vue.prototype.$api = api;
import jhCore from "jh-core";
Vue.use(jhCore, router, resetRouter, getGlobalConfig);
import jhMessage from "jh-message";
Vue.use(jhMessage, router, resetRouter, getGlobalConfig);
import jhAuth from "jh-auth";
Vue.use(jhAuth, router, resetRouter, getGlobalConfig);
import jhBase from "jh-base";
Vue.use(jhBase, router, resetRouter, getGlobalConfig);
import jhLog from "jh-log";
Vue.use(jhLog, router, resetRouter, getGlobalConfig);
import jhTask from "jh-task";
Vue.use(jhTask, router, resetRouter, getGlobalConfig);
import jhEncrypt from "jh-encrypt";
Vue.use(
  jhEncrypt,
  {
    SM4Key: "jhkj@123pass#678",
    tripleDESKey: "jhkj@123pass#67801234567"
  },
  getGlobalConfig
);
// import jhSso from "jh-sso";
// console.log(jhSso);
// var sso = jhSso.init({
//   urlParamKey: "portal_sso_login_ticket",
//   headerKey: "Portal-SSO-Auth-Ticket",
//   ssoUrl: "http://115.233.221.131:26201",
//   redirectUrl: "#/home"
// });
// import jhFormTemplate from 'jh-form-template';
// Vue.use(jhFormTemplate,router,resetRouter,getGlobalConfig);
// import jhFileTemplate from 'jh-file-template';
// Vue.use(jhFileTemplate,router,resetRouter,getGlobalConfig);
//水印指令
import warterMark from "@/jh/functions/warterMark";
Vue.directive("warterMark", warterMark);
import plugin from "./components";
plugin(Vue);
//项目所有工具方法
import utils from "./functions/utils";
Vue.use(utils);
//打印组件
import Print from "vue-print-nb";
Vue.use(Print); //注册
//全局设置尺寸
console.log(ELEMENT);
ELEMENT.TableColumn.props.showOverflowTooltip.default = true;
ELEMENT.TableColumn.props.align.default = "center";
ELEMENT.Table.props.stripe.default = false;
ELEMENT.Table.props.border.default = true;
ELEMENT.Dialog.props.closeOnClickModal.default = false;
ELEMENT.Dialog.props.top.default = "5vh";
ELEMENT.Pagination.props.pageSizes.default = () => {
  return [20, 50, 100, 200];
};
ELEMENT.Pagination.props.background.default = true;
Vue.prototype.$ELEMENT.size = "small";
Vue.config.productionTip = false;
//全局自动注入data/api下所有接口方法
const dataFiles = require.context("./data/api", true, /\.js$/);
const data = dataFiles.keys().reduce((data, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, "$1");
  const value = dataFiles(modulePath);
  data[moduleName] = value.default;
  return data;
}, {});
Vue.prototype.$apiData = data;

import Vue from "vue";
import VScaleScreen from "v-scale-screen";
Vue.use(VScaleScreen);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js